import { render, staticRenderFns } from "./Guest_order_summary.vue?vue&type=template&id=29595f3b&"
import script from "./Guest_order_summary.vue?vue&type=script&lang=js&"
export * from "./Guest_order_summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports